import { LearnService, LearnListResponse, LearnItem, MediaType } from "@domain/learn/learn-service";
import { UserManager } from "@domain/user/user-manager";
import { observable, WritableObservable } from "micro-observables";

const updateObservable = <T>(writableObservable: WritableObservable<T>, value: T): void => {
	if (writableObservable.get() !== value) writableObservable.set(value);
};

export class LearnManager {
	private called = false;
	private readonly _hasItems = observable(false);
	hasItems = this._hasItems.readOnly();

	constructor(
		private readonly learnService: LearnService,
		private readonly userManager: UserManager,
	) {
		this.userManager.user.subscribe(user => {
			if (user && !this.called) {
				this.called = true;
				void this.callLearn();
			}
			if (!user) {
				this.called = false;
			}
		});
	}

	private async callLearn(): Promise<void> {
		try {
			// call getItems(0,1) to determine if the Learn endpoint has any items
			const resp = await this.learnService.getItems(0, 1);
			updateObservable(this._hasItems, resp.totalItems > 0 || resp.items.length > 0);
		} catch (e) {
			// eslint-disable-next-line no-console
			console.warn("[LearnManager] failed to call learn endpoint", e);
		}
	}

	async getItems(page = 0, pageSize = 20, mediaType?: MediaType): Promise<LearnListResponse> {
		const resp = await this.learnService.getItems(page, pageSize, mediaType);
		if (page === 0 && pageSize === 1 && mediaType === undefined) {
			updateObservable(this._hasItems, resp.totalItems > 0 || resp.items.length > 0);
		}
		return resp;
	}

	async getItem(documentId: string): Promise<LearnItem> {
		return this.learnService.getItem(documentId);
	}
}
